<template>
  <v-card>
    <v-card-title>
      Zentralpostfach
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        label="Suche"
        outlined
        dense
        clearable
        append-icon="mdi-magnify"
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-subtitle>
      <v-row>
        <v-col
          cols="6"
        >
          <v-checkbox
            v-model="show_eingehende"
          >
            <template
              v-slot:label
            >
              <v-icon
                class="green--text"
              >
                mdi-download
              </v-icon>
              Eingehende anzeigen
            </template>
          </v-checkbox>
        </v-col>
        <v-col
          cols="6"
        >
          <v-checkbox
            v-model="show_ausgehende"
          >
            <template
              v-slot:label
            >
              <v-icon
                class="red--text"
              >
                mdi-upload
              </v-icon>
              Ausgehende anzeigen
            </template>
          </v-checkbox>
        </v-col>
        <v-col
          v-if="!show_eingehende && !show_ausgehende"
          cols="6"
        >
          <v-checkbox
            v-model="show_system"
          >
            <template
              v-slot:label
            >
              <v-icon
                cols="12"
              >
                mdi-cog-transfer-outline
              </v-icon>
              Systemnachrichten anzeigen
            </template>
          </v-checkbox>
        </v-col>
        <v-col
          v-if="!show_eingehende && !show_ausgehende"
          cols="6"
        >
          <v-checkbox
            v-model="show_deleted"
          >
            <template
              v-slot:label
            >
              <v-icon
                cols="12"
              >
                mdi-delete-clock-outline
              </v-icon>
              Gelöschte Nachrichten anzeigen
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-card-subtitle>
    <v-card-text>
      <v-row>
        <v-col>
          <v-divider class="mt-1"></v-divider>
          <v-timeline
            align-top
            dense
          >
            <Postfach_Message
              v-for="(message) in filtered_messages"
              :key="message.id"
              :message="message"
            >

            </Postfach_Message>
            <!---
            <v-timeline-item
              v-for="(message, index) in $store.state.message_center.messages"
              :key="index"
              color="primary"
              :icon="(message.srcSSI == $store.state.device.issi) ? 'mdi-upload' : 'mdi-download'"
              :icon-color="(message.srcSSI == $store.state.device.issi) ? 'red' : 'green'"
            >
              <div
              >
                <div
                  class="font-weight-normal"
                >
                  <strong
                    v-if="message.srcSSI == $store.state.device.issi"
                    style="float:left;"
                  >
                    <Status
                      v-if="message.destSSI in get_Engine_by_ISSI"
                      :engine="get_Engine_by_ISSI[message.destSSI]"
                      :replace_status_with_display-name="true"
                    >
                    </Status>
                    <div
                      v-else
                    >
                      {{message.destSSI}}
                    </div>
                  </strong>
                  <strong
                    v-if="message.destSSI == $store.state.device.issi"
                    style="float:left;"
                  >
                    <Status
                      v-if="message.srcSSI in get_Engine_by_ISSI"
                      :engine="get_Engine_by_ISSI[message.srcSSI]"
                      :replace_status_with_display-name="true"
                    >
                    </Status>
                    <div
                      v-else
                    >
                      {{message.srcSSI}}
                    </div>
                  </strong>
                  {{(message.ts != null) ? ("@" + formate_time(message.ts) + " Uhr") : ''}}
                  <v-btn
                    icon
                    small
                    @click="new_sds = {receiver: message.srcSSI == $store.state.device.issi ? [message.destSSI] : [], text: message.text, flash_sds: message.flash_sds, copy_to_station: message.copy_to_station}"
                  >
                    <v-icon
                    >
                      mdi-forward
                    </v-icon>
                  </v-btn>
                </div>
                <div>


                  <v-icon
                    v-if="message.unread && message.destSSI == $store.state.device.issi"
                    :class="(blink_source) ? 'warning--text' : 'primary--text'"
                    x-large
                    @click="mark_as_read(message.id)"
                  >
                    mdi-email-mark-as-unread
                  </v-icon>
                  {{ message.text }}
                </div>
                <v-progress-linear
                  v-if="!message.confirmed"
                  style="width: 50%"
                  height="15"
                  indeterminate
                >Senden...</v-progress-linear>
              </div>
            </v-timeline-item> --->
          </v-timeline>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Postfach_Message from "./Postfach_Message";
export default {
  name: "Postfach_New",
  components: { Postfach_Message },
  data: () => ({
    search: null,
    show_eingehende: true,
    show_ausgehende: true,
    show_system: false,
    show_deleted: false,
  }),
  computed: {
    filtered_messages() {
      return this.$store.state.message_center.messages.filter((message) => (this.show_system && message.system_message) || (!(!this.show_deleted && message.status == 4)) && (!(!this.show_eingehende && message.srcSSI != this.$store.state.device.issi)) && (!(!this.show_ausgehende && message.srcSSI == this.$store.state.device.issi)));
    }
  },
  methods: {

  },
  created() {
    this.$store.dispatch("update", { "context": "/messages" })
  }
};
</script>

<style scoped>

</style>
